import gql from 'graphql-tag'

export const FRAGMENT_PRODUCT = gql`
  fragment productFragmentDetail on Product {
    id
    title
    isAdultOnly
    urlKey
    mainCategoryUrlKey
    mainMenuUrlKey
    rank {
      count
      rank
    }
    mainVariant {
      id
      productAmount
      brief
      price
      title
      hasSale
      labels
      mediaIds
      variantUrl
      isAvailable
      gift
      hasSale
      inPromotion
      rrpSavePercent
      discountPrice
      discountPromotionPrice
      defaultActualPrice
      promotionPrice
      unitPrice
      priceType
      priceRrp
      promotionEnd
      freeDelivery
      brand {
        title
        url
        mediaId
      }
      benefits {
        id
        name
        firstText
        secondText
        type
        discountPercent
        discountAmount
      }
      availability {
        key
        status
        countMall
        countOutlets
        countSupplier
        countExternal
        countShowrooms
        isAvailable
      }
      estimatedDeliveries(type: $type) {
        home {
          name
          deliveryFrom
          deliveryTo
          locality
          totalPrice
        }
        pup {
          name
          deliveryFrom
          deliveryTo
          locality
          totalPrice
          type
        }
        cac {
          name
          deliveryFrom
          deliveryTo
          locality
          totalPrice
          type
        }
      }
    }
  }
`
